export default [
  {
    value: 'Weekly',
    text: 'Semanal',
  },
  {
    value: 'Biweekly',
    text: 'Quinzenal',
  },
  {
    value: 'Monthly',
    text: 'Mensal',
  },
  {
    value: 'Bimonthly',
    text: 'Bimestral',
  },
  {
    value: 'Quarterly',
    text: 'Trimestral',
  },
];
